import { HomeService, CalculatorService, OpenAPI } from "../api-client";
import env from "@beam-australia/react-env";

OpenAPI.BASE = env("ENERGY_CALCULATOR_API_URL");

export const api = {
    home: HomeService,
    calculator: CalculatorService
}